// src/app/features/muskoka/muskoka-routing.module.ts
import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

// Muskoka
import {MuskokaDashboardComponent} from './components/dashboard/muskoka-dashboard.component';
import {MuskokaListingDetailsFullComponent} from './components/listing-details/muskoka-listing-details-full.component';

// Muskoka Sold
import {SoldDashboardComponent} from './sold-properties/sold-dashboard/sold-dashboard.component';

const routes: Routes = [
  {path: 'sold', component: SoldDashboardComponent},
  {path: 'fulldetails/:addressStr/:cityStr/:MLSNum', component: MuskokaListingDetailsFullComponent},
  {path: 'fulldetails/:MLSNum', component: MuskokaListingDetailsFullComponent},
  {path: ':addressStr/:cityStr/:MLSNum', component: MuskokaListingDetailsFullComponent},
  {path: '', component: MuskokaDashboardComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MuskokaRoutingModule {
}
